import { defineAsyncComponent } from 'vue'
export default {
  consultancy: defineAsyncComponent(() => import("/opt/build/repo/layouts/consultancy.vue").then(m => m.default || m)),
  development: defineAsyncComponent(() => import("/opt/build/repo/layouts/development.vue").then(m => m.default || m)),
  group: defineAsyncComponent(() => import("/opt/build/repo/layouts/group.vue").then(m => m.default || m))
}